import { Popover as HSPopover, PopoverButton as HSPopoverButton, PopoverPanel as HSPopoverPanel } from '@headlessui/react';
import classNames from 'classnames';
import { memo } from 'react';
import { ListItem, ListItemProps } from '../ListItem';

export const PopoverListItem_: React.FC2<ListItemProps> = ({ children, ...props }) => {
  return <ListItem {...props}>{children}</ListItem>;
};
export const PopoverListItem = memo(PopoverListItem_);

type ChildFunction = (props: { open: boolean; close: () => void }) => React.ReactNode;
export interface PopoverProps {
  buttonChild: React.ReactNode;
  buttonClassName?: string;
  panelClassName?: string;
  children: ChildFunction | React.ReactNode;
  className?: string;
  /** Which side of the button the panel opens from (default: its right edge, growing leftwards). */
  anchor?: 'bottom end' | 'bottom start';
  /** Size the panel to its content (one line per item) instead of the fixed width. */
  fitContent?: boolean;
}
const Popover_: React.FC<PopoverProps> = ({ buttonChild, buttonClassName, panelClassName, children, className, anchor = 'bottom end', fitContent, ...props }) => {
  return (
    <HSPopover className={classNames(!className?.includes('absolute') && 'relative', className)} {...props}>
      {({ open, close }) => (
        <>
          <HSPopoverButton as="div" data-popover-trigger className={classNames(buttonClassName, 'flex items-center justify-center outline-none')}>
            {buttonChild}
          </HSPopoverButton>

          <HSPopoverPanel
            transition
            anchor={anchor}
            className={classNames(
              // Base classes unchanged (including the stray quote, which leaves `absolute` inert as it always was).
              "'absolute z-50 transform right-0 bg-white p-2 flex flex-col border border-gray-300 shadow-sm dark:bg-[#313131] dark:text-white dark:border-gray-500 divide-white/5 rounded-xl transition duration-200 ease-in-out [--anchor-gap:10px] data-[closed]:-translate-y-1 data-[closed]:opacity-0",
              fitContent ? 'w-max min-w-48 whitespace-nowrap' : 'w-48',
            )}
          >
            {typeof children === 'function' ? (children as ChildFunction)({ open, close }) : children}
          </HSPopoverPanel>
        </>
      )}
    </HSPopover>
  );
};

export const Popover = memo(Popover_);
